import { createFileRoute } from "@tanstack/react-router";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { ExperienceEconomy } from "@/components/site/ExperienceEconomy";
import { TheMoment } from "@/components/site/TheMoment";
import { WhySports } from "@/components/site/WhySports";
import { WhatIs } from "@/components/site/WhatIs";
import { Moments } from "@/components/site/Moments";
import { Experience } from "@/components/site/Experience";
import { Technology } from "@/components/site/Technology";
import { Flagship } from "@/components/site/Flagship";
import { Business } from "@/components/site/Business";
import { Franchise } from "@/components/site/Franchise";
import { InvestorForm } from "@/components/site/InvestorForm";
import { InvestorDisclaimer } from "@/components/site/InvestorDisclaimer";
import { Closing, Footer } from "@/components/site/Closing";
import { SectionTracking } from "@/components/site/SectionTracking";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "ClutchCube — Step Inside the Most Iconic Moments in Sports" },
      { name: "description", content: "The world's first immersive sports simulation chamber. A scalable franchise platform built for the Experience Economy. Now raising $10M to build the flagship." },
      { property: "og:title", content: "ClutchCube — Step Inside the Moment" },
      { property: "og:description", content: "Immersive LED stadium chambers where fans become the hero. A franchise platform built for the Experience Economy. Investor round now open." },
      { property: "og:type", content: "website" },
    ],
    links: [
      { rel: "preconnect", href: "https://fonts.googleapis.com" },
      { rel: "preconnect", href: "https://fonts.gstatic.com", crossOrigin: "anonymous" },
      { rel: "stylesheet", href: "https://fonts.googleapis.com/css2?family=Anton&family=Inter:wght@400;500;600;700&display=swap" },
    ],
  }),
  component: Index,
});

function Index() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <SectionTracking />
      <Nav />
      <main>
        <Hero />
        <ExperienceEconomy />
        <TheMoment />
        <WhySports />
        <WhatIs />
        <Moments />
        <Experience />
        <Technology />
        <Flagship />
        <Business />
        <Franchise />
        <InvestorForm />
        <Closing />
        <InvestorDisclaimer />
      </main>
      <Footer />
    </div>
  );
}
